export default {"src":"/_next/static/media/Myocardial_Infarction.f469a27a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};